import React, { useEffect, useState } from 'react';
import { FormControl, Grid, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useHistory, useParams } from 'react-router-dom';
import { Constants } from '../endPoints';

export default function ResetPassword() {
  const history = useHistory();
  const { token } = useParams();
  const backgroundImageUrl = `${process.env.PUBLIC_URL}/assets/images/bg-02.jpg`;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');

    if (password.length < 8) {
      setError('Password must be at least 8 characters long.');
      return;
    }

    if (password !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(Constants.resetPassword, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.message || 'Failed to reset password. Please try again.');
        setLoading(false);
        return;
      }

      setMessage(data.message || 'Password has been reset successfully.');

      setTimeout(() => {
        history.push('/login');
      }, 2000);

    } catch (err) {
      setError('A network error occurred. Please try again later.');
      setLoading(false);
    }
  };

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => setError(''), 3000);
      return () => clearTimeout(timer);
    }
  }, [error]);

  return (
    <section className='bgleft loginsec relative min-h-screen mt-20'>
      <div className='mx-auto loginpnel min-h-screen align-items-center'>
        <Grid container columns={12} spacing={0} className='overflow-hidden h-full min-h-screen'>
          <Grid
            item
            lg={6}
            sm={12}
            xs={12}
            style={{ backgroundImage: `url(${backgroundImageUrl})` }}
            className='loginleft bg-cover bg-right-top table'
          >
          </Grid>

          <Grid item lg={6} sm={12} xs={12} className='table loginright'>
            <div className='align-middle table-cell py-14 px-6'>
              <div>
                <Grid item xl={6} lg={7} md={8} xs={12} className="pageheading-wrapper">
                  <div className='pagehding'>
                    <h2 className='mb-8 text-4xl font-semibold text-center headningfont'>Reset Password</h2>
                  </div>

                  <form onSubmit={handleResetPassword} autoComplete="off">
                    <p style={{ fontSize: "16px", marginBottom: "20px", textAlign: "center" }}>
                      Enter your new password below.
                    </p>

                    <div className='logindata'>
                      <FormControl variant="outlined" className='w-full'>
                        <InputLabel htmlFor="new-password">New Password</InputLabel>
                        <OutlinedInput
                          id="new-password"
                          type={showPassword ? 'text' : 'password'}
                          autoComplete="new-password"
                          inputProps={{ autoComplete: "new-password" }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                          label="New Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </FormControl>
                    </div>

                    <div className='logindata'>
                      <FormControl variant="outlined" className='w-full'>
                        <InputLabel htmlFor="confirm-password">Confirm Password</InputLabel>
                        <OutlinedInput
                          id="confirm-password"
                          type={showConfirmPassword ? 'text' : 'password'}
                          autoComplete="new-password"
                          inputProps={{ autoComplete: "new-password" }}
                          endAdornment={
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle confirm password visibility"
                                onClick={handleClickShowConfirmPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                              >
                                {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                              </IconButton>
                            </InputAdornment>
                          }
                          label="Confirm Password"
                          value={confirmPassword}
                          onChange={(e) => setConfirmPassword(e.target.value)}
                          required
                        />
                      </FormControl>
                    </div>

                    {error && (
                      <p
                        className='text-center mb-3 mt-3'
                        style={{
                          color: '#a20000ff',
                          background: '#fdecea',
                          border: '1px solid #f5c2c0',
                          borderRadius: '6px',
                          padding: '10px 14px',
                          fontWeight: 500,
                        }}
                      >
                        {error}
                      </p>
                    )}

                    {message && (
                      <p
                        className='text-center mb-3 mt-3'
                        style={{
                          color: '#0b6b3a',
                          background: '#e6f4ea',
                          border: '1px solid #b7e1c3',
                          borderRadius: '6px',
                          padding: '10px 14px',
                          fontWeight: 500,
                        }}
                      >
                        {message}
                      </p>
                    )}
                    <div className='loginbutn'>
                      <button type="submit" className='submit_btn' disabled={loading}>
                        {loading ? 'Resetting...' : 'Reset Password'}
                      </button>
                    </div>
                  </form>
                </Grid>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </section>
  );
}